import { MenuItems } from '@/hooks/query';
import { Button } from '@nf/ui';

import { SportIcon, FilterLiveIcon } from '@/components/icons/svg-icons';
import { useMenuEditSection } from '@/features/sports-menu/contexts/menu-edit-section-context';
import { useStreamingStore } from '@/store/streaming';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { useRouter } from '@/navigation';
import { useLocale } from 'next-intl';
import { cx, css } from 'styled-system/css';
import { menuIconStyle } from './menu-icon.style';
import { useSiteStore } from '@/store/site';
import { useAnalyseAttribute } from '@/features/next-analyse';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { catcherAnalyseService } from '@/services/catcher-analyse.service';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { KafkaActionSettings, KafkaMarsTypeEnums, KafkaNote } from '@nf/utils-common/constants';
import { Breakpoint } from '@/features/breakpoint';
import { TimeSensitiveNewTag } from '@/features/new-tag';
import { useBreakpoint } from '@/features/breakpoint/contexts';
import dynamic from 'next/dynamic';
import loadingLottie from '@/assets/lottie/icons/sport02.json';

const LottieComponent = dynamic(() => import('lottie-react'), { ssr: false });

export const MenuIcon = ({ menuItem, isActive, index, name, isNew }: { menuItem: MenuItems, isActive: boolean, index: number, name: string, isNew?: boolean}) => {
	const [setStreamingStatus] = useStreamingStore(
		state => [state.setStreamingStatus],
	);
	const { setIsMenuOpen } = useMenuEditSection();
	const resetAllFilter = useSiteStore(state => state.resetAllFilter);
	const view = useAppearanceStore(state => state.view);
	const router = useRouter();
	const locale = useLocale();
	const { breakpoint } = useBreakpoint();
	const nextAnalyseKey = catcherAnalyseService.createTopMenuCatcherKey(menuItem.gameId);
	const taggedElement = useAnalyseAttribute(nextAnalyseKey);
	const { SiteConfigsData: siteConfig } = useGetSiteConfigs();

	const setKafkaPinGoal = () => {
		if (view === ViewEnum.galaxy) return;
		const pinGoalActions = KafkaActionSettings.MarsV1[KafkaMarsTypeEnums.PinGoal];
		const action = {
			'97': pinGoalActions.PinGoal,
		}[menuItem.gameId ?? '']
		if (action) {
			setKafkaNormal({
				note: KafkaNote.MarsV1,
				type: KafkaMarsTypeEnums.PinGoal,
				action: action,
			})
		}
	}
	
	const handleVisit = (href: string) => {
		setKafkaPinGoal();
		if (index <=6 && view !== ViewEnum.galaxy) {
			const kafkaData = {
				type: 2,
				action: index + 2
			}
			setKafkaNormal(kafkaData);
		}
		if (view == ViewEnum.mars && breakpoint <= Breakpoint.sm && (menuItem.gameId === '1' || menuItem.gameId === '2')) {
			setKafkaNormal({
				note: KafkaNote.MarsV1,
				type: 3,
				action: menuItem.gameId === '1' ? 7 : 8,
			})
		}
		router.push(href, { locale });
		setStreamingStatus('', '', []);
		setIsMenuOpen(false);
		resetAllFilter();
	};

	return (
		<Button
			variant="icon"
			data-active={isActive}
			onClick={() => handleVisit(menuItem.href)}
			ref={taggedElement}
			className={menuIconStyle.menuIconButton}
		>
			{isNew ? <TimeSensitiveNewTag text={'N'} /> : null}
			<div className={menuIconStyle.menuIcon}>
				{(view === ViewEnum.galaxy && menuItem.icon === '2' && siteConfig?.EnablePHView) 
					? <LottieComponent animationData={loadingLottie} loop={true} style={{ height: '30px', width: '55px' }} />
					: <SportIcon sportId={menuItem.icon} isColorful={view === ViewEnum.galaxy ? true : isActive} />}
				<div className={cx(menuIconStyle.menuLiveIcon, css({ display: { _mars: menuItem.hasLive ? 'block' : 'none' } }))}>
					<FilterLiveIcon />
				</div>
			</div>
			<div className={menuIconStyle.menuIconText}>{name}</div>
		</Button>
	)

};